import styled from "styled-components";

export const TextareaFieldCss = styled.div`
  text-align: left;
  padding: 0;
  width: 100%;
  min-width: 200px;

  label.textarea__label {
    font-size: 14px;
    font-weight: 500;
    color: #131313;

    .common__required {
      color: #ff0c0c;
    }
  }

  .textarea-container {
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .textarea-wrapper {
    display: flex;
    flex-direction: column;
    border: 1px solid #ebedf2;
    border-radius: 5px;
    padding: 5px;
    background: #fff;
    position: relative;
  }

  .textarea-field {
    width: 100%;
    min-height: 50px;
    border: none;
    padding: 8px;
    font-size: 14px;
    resize: none;
    outline: none;
      background: white;
      color: #575962;
  }

  .char-count {
    font-size: 12px;
    color: #888;
    position: absolute;
    bottom: 5px;
    right: 10px;
  }

  .suggestions-dropdown {
    position: absolute;
    background: white;
    border: 1px solid #ddd;
    border-radius: 5px;
    width: 100%;
    top: 100%;
    left: 0;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    list-style: none;
    padding: 5px;
    margin: 0;
    z-index: 10;
  }

  .suggestions-dropdown li {
    padding: 8px;
    cursor: pointer;
    font-size: 14px;
  }

  .suggestions-dropdown li:hover {
    background: #f0f0f0;
  }

  .common__inputField__error {
    color: #ff0c0c;
  }
`;
